import { Component, Injector, HostBinding, Input, Output, EventEmitter, HostListener, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractValueAccessor } from '../abstract-value-accessor';
import { MakeProvider } from '../abstract-value-accessor/abstract-value-accessor';

enum RadioSize {
  Original = 18,
  Small = 13,
}

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  providers: [MakeProvider(RadioButtonComponent)],
  standalone: false,
})
export class RadioButtonComponent extends AbstractValueAccessor implements OnChanges, OnInit {
  private readonly outerCircle: {
    [key in RadioSize]: { cx: number; cy: number; r: number };
  } = {
    [RadioSize.Original]: {
      cx: 9,
      cy: 9,
      r: 8.5,
    },
    [RadioSize.Small]: {
      cx: 6.5,
      cy: 6.5,
      r: 6,
    },
  };

  private readonly innerCircle: {
    [key in RadioSize]: { cx: number; cy: number; r: number };
  } = {
    [RadioSize.Original]: {
      cx: 9,
      cy: 9,
      r: 5,
    },
    [RadioSize.Small]: {
      cx: 6.5,
      cy: 6.5,
      r: 4,
    },
  };

  @HostBinding('class.chosen')
  private get checked(): boolean {
    return this.value;
  }

  @HostBinding('class')
  private classes = 'radio-button items-center inline-flex';

  get viewBox(): string {
    return `0 0 ${this.size} ${this.size}`;
  }

  get outerCircleConfig(): {
    cx: number;
    cy: number;
    r: number;
    } {
    return this.outerCircle[this.size];
  }

  get innerCircleConfig(): {
    cx: number;
    cy: number;
    r: number;
    } {
    return this.innerCircle[this.size];
  }

  @Input()
  allowToggle: boolean;

  @Input()
  hideButton: boolean;

  @HostBinding('class.pointer-events-none')
  @HostBinding('class.disabled')
  @Input()
  disabled: boolean;

  @Input()
  infoIconTranslationKey: string;

  @Input()
  size: RadioSize = 18;

  @Input()
  get value(): any {
    return super.value;
  }
  set value(value: any) {
    super.value = value;
  }

  @Output()
  toggled = new EventEmitter<boolean>();

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    super.ngOnChanges(simpleChanges);
  }

  toggle(): void {
    this.value = !this.value;
    this.toggled.emit(this.value);
  }

  choose(): void {
    if (!this.value) {
      this.toggle();
    }
  }

  @HostListener('click')
  private click(): void {
    if (this.disabled) {
      return;
    }

    if (this.allowToggle) {
      this.toggle();
    } else {
      this.choose();
    }
  }
}
